import NextImage from 'next/image';
import addImg from 'images/banner/cez_stehovani_energie_780x500.jpg';

export const GalleryCEZ = () => {
    return (
        <>
            <a
                href="https://www.stehovanienergie.cz/?utm_source=bezrealitky&amp;utm_medium=banner_780x500&amp;utm_campaign=online_realitky&amp;utm_term=resite-energie"
                target="_blank"
            >
                <NextImage src={addImg} placeholder="blur" alt="CEZ" />
            </a>
        </>
    );
};
